import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

const MCK = "https://www.mckinsey.com/capabilities/tech-and-ai/our-insights/the-economic-potential-of-generative-ai-the-next-productivity-frontier";
const STATS = [
  { value: "$2.6–4.4", unit: "trillion", caption: "Potential annual economic value from generative AI worldwide.", source: "McKinsey, 2023", href: MCK },
  { value: "75%", caption: "Of that estimated value is concentrated in customer operations, marketing and sales, software engineering, and R&D.", source: "McKinsey, 2023", href: MCK },
  { value: "14%", caption: "Average productivity increase observed among customer-support agents using an AI assistant in one study.", source: "NBER, 2023", href: "https://www.nber.org/digest/20236/measuring-productivity-impact-generative-ai" },
];

export default function AIOpportunity() {
  return (
    <section className="border-t border-fg/10 bg-canvas py-24 sm:py-32">
      <Container>
        <Reveal>
          <Eyebrow className="text-tone">The AI opportunity</Eyebrow>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-light leading-[1.04] tracking-[-0.04em] text-fg sm:text-5xl">
            A major opportunity. Practical value for your business.
          </h2>
        </Reveal>
        <ul className="mt-16 grid gap-12 lg:grid-cols-3 lg:gap-10">
          {STATS.map((s, i) => (
            <Reveal as="li" key={s.value} delay={i * 100} className="min-w-0 border-t border-fg/15 pt-8">
              <p className="font-display text-[2.75rem] font-light leading-none tracking-[-0.045em] text-fg sm:text-6xl lg:text-[3.4rem] xl:text-[3.9rem]">
                <span className="whitespace-nowrap">{s.value}</span>
                {s.unit && <span className="block pt-2 text-[0.55em] tracking-[-0.03em] text-fg/80">{s.unit}</span>}
              </p>
              <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-subtle">{s.caption}</p>
              <a href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`opportunity-source-${i + 1}`}
                className="fa-link mt-4 inline-block rounded-sm font-mono text-[11px] uppercase tracking-[0.16em] text-fg/70 underline decoration-fg/25 underline-offset-4 hover:text-fg hover:decoration-fg/60">
                {s.source}
              </a>
            </Reveal>
          ))}
        </ul>
        <Reveal className="mt-16 border-t border-fg/10 pt-8">
          <p className="max-w-3xl font-display text-xl font-light tracking-[-0.02em] text-fg sm:text-2xl">
            We help you find where AI can make a difference—and turn that opportunity into a working solution.
          </p>
          <p className="mt-4 text-[13px] text-subtle">
            Industry research: estimates and a specific workplace study, not FreelancAI client results.
          </p>
        </Reveal>
      </Container>
    </section>
  );
}
